export default "__VITE_ASSET__C_VLp0eI__"